import React, { useState } from 'react';
import { AiOutlineCloudDownload } from 'react-icons/ai';
import { GrNext, GrPrevious } from 'react-icons/gr';
import { IoIosArrowBack } from 'react-icons/io';
import { pdfjs, Document, Page } from 'react-pdf/dist/esm/entry.webpack';
import Loader from '../../../common/Loader';
pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.js`;

type Props = {
    fileObject: string;
    fileName: string;
    redirectToDealDetails: () => void;
    isDownloadable: boolean;
    onDownload: () => void;
};
const PDFPagination: React.FC<Props> = ({
    fileObject,
    redirectToDealDetails,
    fileName,
    isDownloadable,
    onDownload,
}) => {
    const [pageNumber, setPageNumber] = useState(0);
    const [numPages, setNumPages] = useState(0);
    const [fileLoadSuccess, setFileLoadSuccess] = useState(false);

    const onDocumentLoadSuccess = (pdfProps: any) => {
        setNumPages(pdfProps.numPages);
        setFileLoadSuccess(true);
    };

    return (
        <div className="overflow-hidden m-auto relative">
            <Document
                file={fileObject}
                onLoadSuccess={onDocumentLoadSuccess}
                options={{
                    cMapUrl: `//cdn.jsdelivr.net/npm/pdfjs-dist@${pdfjs.version}/cmaps/`,
                    cMapPacked: true,
                }}
            >
                <div>
                    <div className="flex justify-between py-4 items-center">
                        <div className="flex items-center">
                            <IoIosArrowBack
                                className="cursor-pointer mr-2"
                                size="1.4rem"
                                color="#c49a6d"
                                onClick={redirectToDealDetails}
                            />
                            <p className="text-lg SourceSansPro-Bold" style={{ color: '#16365c' }}>
                                {fileName}
                            </p>
                        </div>
                    </div>
                </div>
                <Page
                    pageIndex={pageNumber}
                    width={window.innerWidth - 50}
                    renderMode="canvas"
                    loading={<Loader />}
                    renderAnnotationLayer={false}
                />
                <div className="flex justify-between items-center py-4">
                    <div>
                        {fileLoadSuccess && isDownloadable && (
                            <AiOutlineCloudDownload
                                size="1.6rem"
                                className="cursor-pointer"
                                color="#c49a6d"
                                onClick={onDownload}
                            />
                        )}
                    </div>
                    {numPages && (
                        <div className="bg-white shadow rounded p-2 flex items-center mb-16">
                            <GrPrevious
                                size="1.2rem"
                                className={`mr-2 ${pageNumber === 0 ? 'opacity-20' : ''}`}
                                onClick={() => {
                                    if (pageNumber !== 0) {
                                        setPageNumber(pageNumber - 1);
                                    }
                                }}
                            />
                            {pageNumber + 1} of {numPages}
                            <GrNext
                                size="1.2rem"
                                className={`ml-2 ${pageNumber + 1 === numPages ? 'opacity-20' : ''}`}
                                onClick={() => {
                                    if (pageNumber + 1 !== numPages) {
                                        setPageNumber(pageNumber + 1);
                                    }
                                }}
                            />
                        </div>
                    )}
                </div>
            </Document>
        </div>
    );
};

export default PDFPagination;
